import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import VueAwesomeSwiper from "vue-awesome-swiper";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import $ from "jquery";

// vee-validate
import { ValidationObserver, ValidationProvider, configure, localize, extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import zhTW from "vee-validate/dist/locale/zh_TW.json";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import i18n from "./lang/index";
import VueAMap from "vue-amap";
import App from "./App.vue";
import router from "./router";
import "swiper/swiper-bundle.css";
import moneyFilter from "./filters/money";
import "bootstrap";

// Bus
import "./bus";

Vue.config.productionTip = false;

window.$ = $;

Vue.component("Loading", Loading);
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: "e72d266d5806b33218ad68cd16379d60", // 这里填入你的高德地图API密钥
  plugin: ["AMap.Marker"], // 需要使用的插件（如标记插件）
});

Vue.use(VueAxios, axios);
Vue.use(VueAwesomeSwiper);
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value),
});

// vee-validate
Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});
configure({
  classes: {
    valid: "is-valid",
    invalid: "is-invalid",
  },
});

localize("tw", zhTW);

Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

Vue.filter("money", moneyFilter);

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
